import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const FunctionGoodsReceipt = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M13,8.01035118 L12.999,11 L16.016836,11 L16.016836,13 L12.999,13 L13,16.0660894 L11,16.0660894 L10.999,13 L8.01887681,13 L8.01887681,11 L10.999,11 L11,8.01035118 L13,8.01035118 Z M3,22 L4.5,20.5 L6,22 L7.5,20.5 L9,22 L10.5,20.5 L12,22 L13.5,20.5 L15,22 L16.5,20.5 L18,22 L19.5,20.5 L21,22 L21,2 L19.5,3.5 L18,2 L16.5,3.5 L15,2 L13.5,3.5 L12,2 L10.5,3.5 L9,2 L7.5,3.5 L6,2 L4.5,3.5 L3,2 L3,22 Z" })));
};
export default FunctionGoodsReceipt;
